var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCulture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ipizg63t5b",
    x1: "98.335%",
    x2: "3.016%",
    y1: "90.126%",
    y2: "9.874%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6D00AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6A00FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r785tsi0ja"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.607892 0 0 0 0 0.607803 0 0 0 0 0.607923 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -197) translate(0 182)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M33.678 9.54c-.153-7.553-9.439-13.12-16.743-6.781C9.637-3.576.345 1.983.193 9.539c-.056 2.769 1.126 5.434 3.419 7.709l12.631 12.468c.383.378 1.002.379 1.385 0l12.631-12.468c2.293-2.275 3.475-4.94 3.419-7.709zM16.935 27.651L6.158 17.014h3.448c.345 0 .665-.18.842-.473l.753-1.246 2.812 4.384c.414.645 1.385.587 1.715-.106l3.881-8.129 2.744 5.057c.172.316.503.513.865.513h4.495L16.935 27.652zm12.677-12.586h-5.808l-3.387-6.241c-.38-.7-1.406-.678-1.751.045l-3.95 8.276-2.711-4.226c-.395-.617-1.298-.594-1.67.021l-1.284 2.125H4.259c-1.417-1.692-2.142-3.571-2.103-5.488.122-6.073 7.923-10.912 14.085-4.797.383.38 1.005.38 1.389 0 7.868-7.808 18.686 2.285 11.982 10.285z",
    transform: "translate(24.726 15)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture);
export default __webpack_public_path__ + "static/media/culture.f5104e4997f29827adc2385cc886b56b.svg";
export { ForwardRef as ReactComponent };